export const itineraryModeSelector = ({itineraryMode}) => itineraryMode